import { render, staticRenderFns } from "./Company-contact-flat-editor.vue?vue&type=template&id=708aab70&scoped=true&"
import script from "./Company-contact-flat-editor.vue?vue&type=script&lang=js&"
export * from "./Company-contact-flat-editor.vue?vue&type=script&lang=js&"
import style0 from "./Company-contact-flat-editor.vue?vue&type=style&index=0&id=708aab70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708aab70",
  null
  
)

export default component.exports